<div mat-dialog-title class="title_container">
  <span class="title_text">Error in submitting form</span>
</div>

<ul
  mat-dialog-content
  class="content_container"
  *ngFor="let error of errors"
>
  <li>
    {{ error?.message || error?.error?.message || error?.statusText || error || 'An unexpected error occurred.' }}
  </li>
</ul>

<div mat-dialog-actions class="cta_container">
  <button mat-button (click)="close()" class="button-primary" cdkFocusInitial>
    CLOSE
  </button>
</div>
